import React from 'react';
import { FormCheck } from 'react-bootstrap';

import { Modal } from 'ui';

import * as selectAlertSettingsUser from 'store/alert_settings_user/alert_settings_user.selector';
import { updateAlertSettingsUser } from 'store/alert_settings_user/alert_settings_user.action';

import { useAppDispatch, useAppSelector } from 'store/hooks';

import {
  ModalContent,
  ModalHeader,
  ModalHeaderTitle,
  ModalTable,
} from './modal-alert-settings.styles';

interface ModalAlertSettingsProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const ModalAlertSettings = ({
  showModal,
  setShowModal,
}: ModalAlertSettingsProps) => {
  const dispatch = useAppDispatch();

  const alertSettingsUserList = useAppSelector(
    selectAlertSettingsUser.alertSettingsUserList
  );

  const handleOptionChange = (
    alertSettingsId: number,
    system: boolean,
    email: boolean,
    whatsapp: boolean
  ) => {
    dispatch(
      updateAlertSettingsUser({ alertSettingsId, email, system, whatsapp })
    );
  };

  return (
    <Modal
      show={showModal}
      size="lg"
      title="Configuração de alertas"
      close={() => setShowModal(false)}
    >
      <ModalContent>
        <ModalTable>
          <thead>
            <th></th>
            <th>Sistema</th>
            <th>E-mail</th>
            <th>WhatsApp</th>
          </thead>
          <tbody>
            {alertSettingsUserList.map((x) => (
              <tr key={x.alertSettings.id}>
                <td>{x.alertSettings.text}</td>
                <td>
                  <FormCheck
                    type="checkbox"
                    name="system"
                    onChange={(e) =>
                      handleOptionChange(
                        x.alertSettings.id,
                        e.target.checked,
                        x.email,
                        x.whatsapp
                      )
                    }
                    checked={x.system}
                  />
                </td>
                <td>
                  <FormCheck
                    type="checkbox"
                    name="email"
                    onChange={(e) =>
                      handleOptionChange(
                        x.alertSettings.id,
                        x.system,
                        e.target.checked,
                        x.whatsapp
                      )
                    }
                    checked={x.email}
                  />
                </td>
                <td>
                  <FormCheck
                    type="checkbox"
                    name="whatsapp"
                    onChange={(e) =>
                      handleOptionChange(
                        x.alertSettings.id,
                        x.system,
                        x.email,
                        e.target.checked
                      )
                    }
                    checked={x.whatsapp}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </ModalTable>
      </ModalContent>
    </Modal>
  );
};
